import React from 'react'
import { Typography, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useAtomValue } from 'jotai'

import { aiPhraseAtom } from 'atoms'

const PhraseDebugger = () => {
  const { t } = useTranslation()
  const phrase = useAtomValue(aiPhraseAtom)

  return (
    <Box my={4}>
      {phrase && <Typography variant="h6">{t('sentenceGenerated')}</Typography>}
      <Typography variant="body1" paragraph>
        {phrase}
      </Typography>
    </Box>
  )
}

export default PhraseDebugger
